import { render, staticRenderFns } from "./CoEditorContent.vue?vue&type=template&id=17c49ba1&scoped=true&"
import script from "./CoEditorContent.vue?vue&type=script&lang=ts&"
export * from "./CoEditorContent.vue?vue&type=script&lang=ts&"
import style0 from "./CoEditorContent.vue?vue&type=style&index=0&id=17c49ba1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c49ba1",
  null
  
)

export default component.exports